import { useCallback, useState } from 'react';
import { safeStorage } from '../storage';

export type ThemeName = 'light' | 'dark';

const THEME_KEY = 'lg.theme';

function initialTheme(): ThemeName {
  const saved = safeStorage.get(THEME_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

export function useThemePreference(): [ThemeName, () => void] {
  const [theme, setTheme] = useState<ThemeName>(initialTheme);
  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === 'dark' ? 'light' : 'dark';
      safeStorage.set(THEME_KEY, next);
      return next;
    });
  }, []);
  return [theme, toggle];
}
